/**
 * Раскладка граней псевдо-3D кости урона (см. DamageDice) и ориентации куба,
 * показывающие нужную грань зрителю.
 *
 * Значения граней — ровно те же, что у настоящей кости в getDamageDiceRoll
 * (базовый d6: -3, -2, -1, -1, 0, 0). Повторяющиеся значения лежат на
 * противоположных гранях, как у физической кости: «-1» — front/back, «0» —
 * left/top.
 */
export const DAMAGE_DICE_FACE_LAYOUT = [
  {position: 'front', value: -1},
  {position: 'back', value: -1},
  {position: 'right', value: -2},
  {position: 'left', value: 0},
  {position: 'top', value: 0},
  {position: 'bottom', value: -3},
];

// Грань, на которую кладется значение, которого у кости нет: в записях старых
// партий кости хранятся готовыми значениями, и там встречаются прежние грани
// (+1, а в самых старых записях и -4)
const FOREIGN_VALUE_POSITION = 'top';

// Поворот КУБА, при котором грань смотрит на зрителя, — обратный к повороту
// самой грани в раскладке куба (см. DamageDice.css)
const ORIENTATION_BY_POSITION = {
  front: {x: 0, y: 0},
  back: {x: 0, y: 180},
  right: {x: 0, y: -90},
  left: {x: 0, y: 90},
  top: {x: -90, y: 0},
  bottom: {x: 90, y: 0},
};

const checkIfValueOnDice = (value) => DAMAGE_DICE_FACE_LAYOUT.some((item) => item.value === value);

/**
 * Раскладка граней для показа значения. Обычно — DAMAGE_DICE_FACE_LAYOUT;
 * значение, которого у кости нет (прежние грани из записей старых партий),
 * подменяет собой верхнюю грань, чтобы кость показала ровно то, что выпало
 * в той партии.
 *
 * @param {number} value - показываемое значение урона
 * @returns {Array<{position: string, value: number}>}
 */
export const getDamageDiceFaceLayout = (value) => {
  if (typeof value !== 'number' || checkIfValueOnDice(value)) {
    return DAMAGE_DICE_FACE_LAYOUT;
  }
  return DAMAGE_DICE_FACE_LAYOUT.map((item) => (
    item.position === FOREIGN_VALUE_POSITION ? {...item, value} : item
  ));
};

/**
 * Грань, которой кость показывает выпавшее значение (см. getDamageDiceFaceLayout).
 *
 * @param {number} value - выпавшее значение урона
 * @returns {string} позиция грани (front/back/right/left/top/bottom)
 */
export const getDamageDiceFacePosition = (value) => {
  const face = getDamageDiceFaceLayout(value).find((item) => item.value === value);
  return face ? face.position : 'front';
};

/**
 * Ориентация куба для показа выпавшего значения.
 *
 * @param {number} value - выпавшее значение урона
 * @returns {{x: number, y: number}} углы поворота в градусах
 */
export const getDamageDiceOrientation = (value) => {
  return ORIENTATION_BY_POSITION[getDamageDiceFacePosition(value)];
};
